<template>
  <div class="wrap">
    <el-collapse v-model="activeNames" @change="handleChange">
      <el-collapse-item v-for="option in options" :key="option.name" :title="option.title" :name="option.name">
        <template slot="title">
          <div class="title-container">
            <div class="title-line"></div>
            <div class="title-text">{{ option.title }}</div>
          </div>
        </template>
        <fieldVue
          v-if="['form', 'initiator', 'processNode'].includes(option.name)"
          :option="option"
          :showHeader="option.name === 'form'"
          headerText="业务模型："
          :addTableName="option.addTableName"
          :tableName="option.children[0]?.tableName"
          :businessName="option.children[0]?.businessName"
          :groupName="option.children[0]?.tableName"
        ></fieldVue>
        <customField v-if="['customData', 'customField'].includes(option.name)" ref="customField" :option="option" :getAllFieldName="getAllFieldName"></customField>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>
<script>
import mongeService from "@/CommonDP/mongeView/service/monge-service.js";
import fieldVue from "./components/field";
import customField from "./components/customField";
import { mapState } from "vuex";
export default {
  components: { fieldVue, customField },
  data() {
    return {
      options: [
        { title: "表单", name: "form", children: [], addTableName: true },
        { title: "流程发起人", name: "initiator", children: [], addTableName: false },
        { title: "流程信息", name: "processNode", children: [], addTableName: false },
        // { title: "企业签章", name: "document", children: [], addTableName: false },
        // { title: "文件", name: "companySeal", children: [], addTableName: false },
        {
          title: "自定义字段",
          name: "customField",
          children: []
        },
        { title: "自定义数据", name: "customData", children: [] }
      ],
      activeNames: ["form", "initiator", "processNode"],
      immutableFieldName: []
    };
  },
  computed: {
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      prjId: (state) => state.projectMg.prjObj.prjId
    })
  },
  created() {
    this.getFiled();
  },
  methods: {
    translateKey(key) {
      const index = key.indexOf("-");
      return key.slice(index + 1);
    },
    getAllFieldName() {
      const fieldNameArr = [];
      [3].map((index) => {
        const option = this.options[index];
        option.children.map((item) => {
          fieldNameArr.push(item.customizedFieldName);
        });
      });
      return fieldNameArr.concat(this.immutableFieldName);
    },
    async getFiled() {
      const { currentVersionId: flowVersionId, flowDefinitionId, flowKey } = this.$route.query;
      const res = await mongeService.getDesignFormField(flowVersionId, flowDefinitionId, flowKey, this.prjId, this.enterpriseId);
      this.options[0].children = res.data.formFields.map((item) => {
        if (item.children) {
          item.children = item.children.map((child) => {
            child.name = this.translateKey(child.name);
            this.immutableFieldName.push(child.name);
            return {
              ...child,
              valueType: 2
            };
          });
        } else {
          this.immutableFieldName.push(item.name);
        }
        return {
          ...item,
          valueType: 1
        };
      });
      this.options[1].children = res.data.flowStartUserFields.map((item) => {
        this.immutableFieldName.push(item.name);
        return {
          ...item,
          valueType: 1
        };
      });
      this.options[2].children = res.data.flowFields.map((item) => {
        this.immutableFieldName.push(item.name);
        return {
          ...item,
          valueType: 1
        };
      });
      this.options[3].children = res.data.customFields || [];
      this.options[4].children = [
        {
          customizedMethod: res.data.customizedMethod || "",
          customizedSql: res.data.customizedSql || ""
        }
      ];
      console.log(res);
    },
    handleChange(activeNames) {
      this.activeNames = activeNames;
    },
    revertField() {
      return {
        formFields: this.options[0].children,
        flowStartUserFields: this.options[1].children,
        flowFields: this.options[2].children
      };
    },
    getCustomField() {
      return {
        customizedMethod: this.options[4].children[0].customizedMethod,
        customizedSql: this.options[4].children[0].customizedSql,
        customFields: this.options[3].children
      };
    }
  }
};
</script>

<style lang="less" scoped>
.wrap {
  height: 100%;
  overflow: auto;
  .title-container {
    display: flex;
    align-items: center;
  }

  .title-line {
    width: 4px; /* 竖线宽度 */
    height: 20px; /* 竖线高度 */
    background-color: #333; /* 竖线颜色 */
    margin-right: 10px; /* 竖线与文字之间的间距 */
  }

  .title-text {
    font-size: 15px; /* 文字大小 */
    font-weight: bold; /* 文字粗细 */
    color: #333; /* 文字颜色 */
  }
}

::v-deep .el-collapse-item__content {
  padding-bottom: 8px;
}
</style>
